import formAdminUsers from './formAdminUsers';
import formLiveSettings from './formLiveSettings';

export default {
  title: 'Live Setting',
  attributeName: 'livesettings',
  getURL: 'livesettings',
  createURL: 'livesettings',
  updateURL: 'livesettings',
  additionaMetadataURL: '',
  removeURL: '',
  canCreate: true,
  idAttribute: 'id',
  sessionParams: [],
  formConfig: [formLiveSettings],
  noArea: true,
  goBack: true,
};
